import { SupportedChains } from '.';

interface BaseChainInfo {
    readonly chainId: string;
    readonly rpcUrls: string[];
    readonly chainName: string;
    readonly nativeCurrency: {
        name: string;
        decimals: number;
        symbol: string;
    };
}

type ChainInfoMap = { readonly [chainId: number]: BaseChainInfo };

const CHAIN_INFO: ChainInfoMap = {
    [SupportedChains.ARBITRUM_ONE]: {
        chainId: '0xa4b1',
        rpcUrls: ['https://arb1.arbitrum.io/rpc'],
        chainName: 'Arbitrum One',
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    },
};

export const getChainInfo = (chainId: any): any => {
    if (chainId) {
        return CHAIN_INFO[chainId] ?? undefined;
    }
    return undefined;
};
